import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../app/store';

interface AuthState {
  apiToken?: string | null;
}

const initialState: AuthState = {
  apiToken: null,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    initAuthState: () => initialState,
    setApiToken: (state, action: PayloadAction<string | null>) => {
      state.apiToken = action.payload;
    },
  },
});

export const { initAuthState, setApiToken } = authSlice.actions;

export const selectApiToken = (state: RootState) => state.auth.apiToken;

export default authSlice.reducer;
